export const isProdNodeEnv = process.env.NODE_ENV === 'production';
export const isLocalNodeEnv = process.env.NODE_ENV === 'development';

export const isProd = process.env.NEXT_PUBLIC_ENV === 'prod';
export const isStage = process.env.NEXT_PUBLIC_ENV === 'stage';
export const isDev = process.env.NEXT_PUBLIC_ENV === 'dev';

export const isGitlabCI =
  process.env.CI === 'true' ||
  process.env.GITHUB_ACTIONS === 'true' ||
  process.env.GITLAB_CI === 'true' ||
  process.env.BITBUCKET_BUILD_NUMBER !== undefined;

export const envLocale = process.env.NEXT_PUBLIC_LOCALE;

export const showLogger = isLocalNodeEnv
  ? true
  : process.env.NEXT_PUBLIC_SHOW_LOGGER === 'true' ?? false;

export const isBuildPhase = process.env.NEXT_PHASE === 'phase-production-build';

export const cmsApiEndpoint =
  isBuildPhase && !isDev
    ? 'https://decodo.com/cms-api'
    : process.env.NEXT_PUBLIC_STRAPI_API_URL;

export const nextApiEndpoint = isDev
  ? 'http://localhost:3000/next-api'
  : `http://decodo-website-nginx:8088/next-api`;
// TODO remove after moving to decodo, just a temp solution for smartconnection
export const currentDomain = process.env.NEXT_PUBLIC_DOMAIN ?? 'decodo.com';
